import gql from "graphql-tag";
import AssetDiscussionCommentFields from "../../fragments/AssetDiscussionCommentFields";
import AssetDiscussionCommentRepliesPaginationFields from "../../fragments/AssetDiscussionCommentRepliesPaginationFields";
import AssetDiscussionCommentParticipantsFields from "../../fragments/AssetDiscussionCommentParticipantsFields";

export default gql`
  mutation PostCommentOnAsset(
    $country: String!
    $assetType: AssetType!
    $assetId: ObjectID!
    $bodyAsPlainText: String!
  ) {
    postCommentOnAsset(country: $country, assetType: $assetType, assetId: $assetId, bodyAsPlainText: $bodyAsPlainText) {
      __typename
      ...AssetDiscussionCommentFields
      replies {
        ...AssetDiscussionCommentRepliesPaginationFields
      }
      participants(top: 5) {
        ...AssetDiscussionCommentParticipantsFields
      }
    }
  }

  ${AssetDiscussionCommentFields}
  ${AssetDiscussionCommentRepliesPaginationFields}
  ${AssetDiscussionCommentParticipantsFields}
`;
